import React from "react";
import Formulario from "./Formulario";


import { Container, Row, Col } from "react-bootstrap";

import "../styles/Contenido.css";
import "../styles/util.css";


function Contenido() {
  return (
    <div className="form with-form">
      
      <Container >
        <h1 className="">Consulta de Coeficientes de Distribución</h1>      
        <Row>
          <Col sm={12} className="mt-3">
            <div className=""              
            >              
              Ingrese su Nº de CUIT y Período (Año y Mes) para consultar su
              inclusión en el Padrón:              
            </div>
            <Formulario />
           
            {/*  <Pie /> <MensajePie />*/}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Contenido;
